import { inject, OnDestroy } from '@angular/core';
import { NeoLogService } from '../neo-log.service';
import { BehaviorSubject, Subject } from 'rxjs';

import { Injectable } from '@angular/core';
import { NeoStatus } from '@app/models/status.model';

@Injectable({
  providedIn: 'root',
})
export class NeoBaseService implements OnDestroy {

  // ---------------------------------------------------------
  // Add common features here like:
  // ---------------------------------------------------------

  // Events
  public NeoStatus = NeoStatus;
  public status: NeoStatus = NeoStatus.idle;
  public statusSubject: BehaviorSubject<NeoStatus> = new BehaviorSubject<NeoStatus>(this.status);
  public status$ = this.statusSubject.asObservable();

  // Services
  public neoLogService = inject(NeoLogService);

  // ---------------------------------------------------------
  // Cleanup subscriptions
  public destroy$: Subject<boolean> = new Subject<boolean>();
  // ---------------------------------------------------------

  public setInitial(): void {
    this.setStatus(NeoStatus.initial);
  }

  public setInitialising(): void {
    this.setStatus(NeoStatus.initialising);
  }

  public setLoading(): void {
    this.setStatus(NeoStatus.loading);
  }

  public setProcessing(): void {
    this.setStatus(NeoStatus.processing);
  }

  public setError(): void {
    this.setStatus(NeoStatus.error);
  }

  public setIdle(): void {
    this.setStatus(NeoStatus.idle);
  }

  public setStatus(status: NeoStatus): void {
    this.status = status;
    this.statusSubject.next(this.status);
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
